import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';

var ChartXaxis = function ChartXaxis(_ref) {
  var height = _ref.height,
      hover = _ref.hover,
      ticks = _ref.ticks,
      width = _ref.width,
      xAxisOffset = _ref.xAxisOffset,
      scale = _ref.scale,
      dateFormat = _ref.dateFormat;
  var hoverPosition;
  var hoverText;
  var hoverLabelXOffset;
  var hoverLabelYOffset;
  var hoverX;
  var hoverAnchor;

  if (hover) {
    // eslint-disable-next-line prefer-destructuring
    hoverPosition = hover.hoverPosition; // eslint-disable-next-line prefer-destructuring

    hoverText = hover.hoverText;
    hoverLabelXOffset = hover.hoverLabelXOffset || 0;
    hoverLabelYOffset = hover.hoverLabelYOffset || 0;
    hoverX = hoverPosition - xAxisOffset;
    hoverAnchor = hoverX < 0 ? 'start' : 'middle';

    if (hoverPosition + xAxisOffset >= width) {
      hoverX = width - xAxisOffset - hoverLabelXOffset;
      hoverAnchor = 'end';
    }
  }

  return React.createElement("g", {
    className: "ChartXaxis",
    transform: "translate(".concat(xAxisOffset, ", 0)")
  }, hover ? React.createElement("text", {
    className: "ChartXaxis-hover-text",
    x: hoverX,
    y: height - hoverLabelYOffset,
    textAnchor: hoverAnchor
  }, hoverText) : null, ticks.map(function (tick) {
    return hover ? null : React.createElement("g", {
      key: tick
    }, React.createElement("text", {
      className: "ChartXaxis-label",
      x: scale(tick),
      y: height
    }, moment(tick).format(dateFormat)));
  }));
};

ChartXaxis.propTypes = {
  height: PropTypes.number.isRequired,
  hover: PropTypes.object,
  ticks: PropTypes.array.isRequired,
  width: PropTypes.number.isRequired,
  xAxisOffset: PropTypes.number.isRequired,
  scale: PropTypes.func.isRequired,
  dateFormat: PropTypes.string
};
ChartXaxis.defaultProps = {
  dateFormat: 'll'
};
ChartXaxis.displayName = 'ChartXaxis';
export default ChartXaxis;